/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ van: NonNullable<unknown>, tot: NonNullable<unknown> }} Planning_Vakanties_Buiten_BereikInputs */

const nl_planning_vakanties_buiten_bereik = /** @type {(inputs: Planning_Vakanties_Buiten_BereikInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kies een dag van ${i?.van} tot en met ${i?.tot}.`)
};

/**

* @param {Planning_Vakanties_Buiten_BereikInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_buiten_bereik = /** @type {((inputs: Planning_Vakanties_Buiten_BereikInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Buiten_BereikInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_buiten_bereik(inputs)
});
export { planning_vakanties_buiten_bereik as "planning.vakanties.buiten_bereik" }